export default "__VITE_PUBLIC_ASSET__325ea5aa__"